import ToastIcon from '@assets/images/toast-icon.svg?react'
import { ButtonVariantEnum, CustomPopper } from '@atbay/component-lib'
import { useCustomTheme } from '@/core/theme'
import { FC } from 'react'
import {
    Footer,
    Header,
    StyleButton,
    TriggerWrapper,
} from './popConfirm.styles'
import Typography from '../typography'
import { usePopConfirm } from './usePopConfirm'
import { TPopConfirmProps } from './popConfirm.types'

const PopConfirm: FC<TPopConfirmProps> = ({
    dataTestId,
    title,
    description,
    onCancel,
    onConfirm,
    children,
    okText = 'Yes',
    cancelText = 'No',
    placement = 'right',
}) => {
    const theme = useCustomTheme()
    const {
        open,
        anchorEl,
        id,
        popperRef,
        handleClick,
        handleCancel,
        handleConfirm,
        popperStyles,
        buttonColors,
    } = usePopConfirm(onCancel, onConfirm)

    return (
        <>
            <TriggerWrapper onClick={handleClick}>{children}</TriggerWrapper>
            <CustomPopper
                placement={placement}
                open={open}
                id={id}
                anchorEl={anchorEl as HTMLElement}
                setOpen={() => {}}
                disablePortal={false}
                rootStyles={popperStyles}
            >
                <div ref={popperRef} data-testid={dataTestId}>
                    <Header>
                        <ToastIcon color={theme.colors.semantic.warning} />
                        <Typography variant="xs-bold">{title}</Typography>
                    </Header>
                    <Typography
                        variant="s-regular"
                        color={theme.colors.greys[700]}
                    >
                        {description}
                    </Typography>
                    <Footer>
                        <StyleButton
                            className="cancel-button"
                            textColor={buttonColors.cancel.text}
                            backgroundColor={buttonColors.cancel.background}
                            hoverBackgroundColor={buttonColors.cancel.hover}
                            onClick={handleCancel}
                            testId="cancel-button"
                            buttonVariant={ButtonVariantEnum.ROUNDED}
                        >
                            {cancelText}
                        </StyleButton>
                        <StyleButton
                            textColor={buttonColors.confirm.text}
                            backgroundColor={buttonColors.confirm.background}
                            hoverBackgroundColor={buttonColors.confirm.hover}
                            onClick={handleConfirm}
                            testId="ok-button"
                        >
                            {okText}
                        </StyleButton>
                    </Footer>
                </div>
            </CustomPopper>
        </>
    )
}

export default PopConfirm
